import InsuredInfo from './InsuredInfo';
export default InsuredInfo;
